function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a555fdc1-543d-4707-ad9f-6ab871925265",
  x1: 403.53,
  y1: 329.2,
  x2: 403.53,
  y2: 58.05,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b5cd2d76-14a4-40b4-8065-15ea8dd506d0",
  x1: 517.81,
  y1: 472.14,
  x2: 647.31,
  y2: 472.14,
  gradientTransform: "translate(-58.47 81.57) rotate(-5.9)",
  xlinkHref: "#a555fdc1-543d-4707-ad9f-6ab871925265"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M824,293.65a7.55,7.55,0,0,0,1.37-4.2c0-9.12-18.58-16.5-41.5-16.5s-41.5,7.38-41.5,16.5a7.78,7.78,0,0,0,1.71,4.68c-25.52,2.85-42.71,8.19-42.71,14.32,0,9.11,38,16.5,85,16.5s85-7.39,85-16.5C871.32,302,852,296.35,824,293.65Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f",
  opacity: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M940.55,771.87a47.86,47.86,0,0,0-.43,7.86q26.14.42,52.51,1.76c.12-.68.24-1.39.34-2.1a41.75,41.75,0,0,0-2.45-21.72c-3.62-8.83-10.37-15.14-18.82-16.35s-16.69,2.94-22.64,10.35A41.66,41.66,0,0,0,940.55,771.87Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 972.8,
  cy: 733.7,
  rx: 34.66,
  ry: 26.48,
  transform: "translate(77.72 1534.19) rotate(-81.82)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 978.82,
  cy: 691.77,
  rx: 34.66,
  ry: 26.48,
  transform: "translate(124.39 1504.19) rotate(-81.82)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 984.85,
  cy: 649.84,
  rx: 34.66,
  ry: 26.48,
  transform: "translate(171.06 1474.19) rotate(-81.82)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 990.88,
  cy: 607.91,
  rx: 34.66,
  ry: 26.48,
  transform: "translate(217.73 1444.19) rotate(-81.82)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1130.21,335.07a128.68,128.68,0,0,0,11.83-13L1074.8,300.9l74.4,11.26A127.08,127.08,0,0,0,1165.89,213l-107.36,37.47L1160.4,196A126.83,126.83,0,1,0,932.88,306.71a127,127,0,0,0-17.6,20.84L998,386.83l-90.71-45.68a126.87,126.87,0,0,0,3.3,120.78,126.82,126.82,0,1,0,197.33,28.36,126.84,126.84,0,0,0,22.3-155.22Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M894.87,380.46a126.23,126.23,0,0,0,15.71,81.47,126.82,126.82,0,1,0,197.33,28.36C1127.8,471.35,896.89,366.37,894.87,380.46Z",
  transform: "translate(-30.47 -58.05)",
  opacity: 0.1
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M196.93,734.8a40.64,40.64,0,0,0,1.75,6.64q21.31-6.86,43.06-13c-.08-.6-.17-1.22-.28-1.84a36.8,36.8,0,0,0-7.78-17.36c-5.29-6.33-12.45-9.71-19.63-8.38s-12.76,7-15.61,14.84A37.31,37.31,0,0,0,196.93,734.8Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 212.91,
  cy: 694.22,
  rx: 22.64,
  ry: 30.29,
  transform: "translate(-136.29 -16.27) rotate(-8.99)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 206.61,
  cy: 657.74,
  rx: 22.64,
  ry: 30.29,
  transform: "matrix(0.99, -0.16, 0.16, 0.99, -130.67, -17.7)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 200.31,
  cy: 621.27,
  rx: 22.64,
  ry: 30.29,
  transform: "translate(-125.05 -19.13) rotate(-8.99)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 194.02,
  cy: 584.8,
  rx: 22.64,
  ry: 30.29,
  transform: "translate(-119.43 -20.57) rotate(-8.99)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M234.29,319.86a113,113,0,0,0,6.13-14l-60.2.94,63.36-11.17a113.23,113.23,0,0,0,1.88-47.46,111.89,111.89,0,0,0-14.78-39.43l-77.11,60.71,68.12-73.33c-24.08-29.19-62.3-44.76-101.74-37.5C61,169.44,21.73,227.12,32.14,287.42a110.72,110.72,0,0,0,34.48,63.31,112.29,112.29,0,0,0-8.73,22.15l82.92,26.41L55,386.38a113.22,113.22,0,0,0,.42,36.06,110.72,110.72,0,0,0,34.48,63.31,112.94,112.94,0,0,0-11.17,71.71c10.41,60.31,66.6,100.4,125.51,89.55s98.22-68.52,87.81-128.83a110.75,110.75,0,0,0-34.48-63.3,113,113,0,0,0,11.17-71.72A110.75,110.75,0,0,0,234.29,319.86Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.45,422.44a110.72,110.72,0,0,0,34.48,63.31,112.94,112.94,0,0,0-11.17,71.71c10.41,60.31,66.6,100.4,125.51,89.55s98.22-68.52,87.81-128.83a110.75,110.75,0,0,0-34.48-63.3C268.69,433.66,53.33,410.19,55.45,422.44Z",
  transform: "translate(-30.47 -58.05)",
  opacity: 0.1
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M144.32,651.45c0,52.31,32.81,94.63,73.36,94.63",
  transform: "translate(-30.47 -58.05)",
  fill: "#46455b"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M217.68,746.08c0-52.89,36.62-95.69,81.88-95.69",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M170.9,656.19c0,49.69,20.92,89.89,46.78,89.89",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M217.68,746.08c0-67.58,42.33-122.27,94.64-122.27",
  transform: "translate(-30.47 -58.05)",
  fill: "#46455b"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 527.85,
  cy: 727.56,
  rx: 511,
  ry: 16.99,
  fill: "#2a9d8f",
  opacity: 0.1
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 178.74,
  cy: 698.3,
  rx: 18.68,
  ry: 3.16,
  fill: "#2a9d8f",
  opacity: 0.1
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M196.66,741.67s10.66-.32,13.87-2.61,16.38-5,17.18-1.35,16,18.24,4,18.33-27.94-1.87-31.15-3.82S196.66,741.67,196.66,741.67Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#a8a8a8"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M231.91,754.77c-12,.09-27.95-1.88-31.15-3.83-2.44-1.48-3.42-6.82-3.74-9.28h-.36s.68,8.6,3.88,10.55,19.13,3.92,31.15,3.82c3.47,0,4.67-1.26,4.61-3.09C235.82,754.06,234.49,754.75,231.91,754.77Z",
  transform: "translate(-30.47 -58.05)",
  opacity: 0.2
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M718,257c-14.35-70.72-75.85-124-150.67-124-59.45,0-110.7,33.82-136.33,83-61.5,6.15-109.67,58.42-109.67,122,0,67.64,55.34,123,123,123h266.5c56.37,0,102.5-46.13,102.5-102.5A101.25,101.25,0,0,0,718,257ZM600.12,317.45v77.9h-65.6v-77.9h-69.7L567.32,215l102.5,102.5Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M467.08,305.75c-1-5.71-.51-11.86-3.13-17a3.7,3.7,0,0,0-1.19-1.53,4.11,4.11,0,0,0-2.13-.49c-2.37-.09-4.73-.12-7.1-.06-.66,0-1.44.1-1.78.68a.72.72,0,0,0-.09.2c-2.71-3-4.76-6.79-7.68-9.59.42-.14.83-.27,1.26-.38,0-.29-.1-.56-.16-.84,0-.09-.05-.17-.07-.25s-.09-.38-.15-.57-.06-.19-.1-.28a5.52,5.52,0,0,0-.18-.53c0-.09-.07-.18-.11-.27l-.21-.53-.12-.25c-.08-.18-.16-.36-.25-.53l-.12-.22c-.09-.19-.19-.38-.29-.57l-.1-.18c-.11-.2-.23-.4-.34-.61a.41.41,0,0,1-.07-.11c-.13-.23-.27-.46-.41-.68h0c-1.14-1.86-2.4-3.69-3.33-5.6-1.63-3.36-2.17-7.15-3.26-10.73s-3-7.22-6.24-8.93c-1.57-.8-3.67-1.51-3.82-3.28a3.91,3.91,0,0,1,.35-1.65,22.1,22.1,0,0,1,1.63-3.31c.24-.38.49-.76.74-1.14l.2-.27c.2-.28.41-.56.62-.82l.26-.33c.21-.26.43-.5.65-.75l.27-.29c.31-.33.62-.65.95-1a2.31,2.31,0,0,0,.7-.89,2.7,2.7,0,0,0,.05-1.06c-.16-2.86,1.34-5.53,3-7.83s3.62-4.48,4.57-7.17c.11-.31.2-.62.28-.94a2.82,2.82,0,0,0,.07-.31c.05-.21.09-.42.13-.64l.06-.36c0-.2.05-.4.07-.59l0-.39,0-.59v-.39c0-.19,0-.39,0-.59s0-.25,0-.38,0-.42-.05-.63l0-.34c0-.24-.07-.49-.1-.73,0-.08,0-.16,0-.24q-.07-.49-.18-1h0a50,50,0,0,0-1.84-6.26,22.37,22.37,0,0,0-1.52-3.64c.37-.07.75-.15,1.12-.25a16.34,16.34,0,0,1-.81-1.42,37.24,37.24,0,0,0,5.11-11.09,51.33,51.33,0,0,0,1-8.57c.55-8.66,1.11-17.36.39-26l0-.34a21,21,0,0,0,.06-5.6,23.52,23.52,0,0,0-3.14-10.33c-1.94-3.06-5.14-5.76-8.7-6.12a13.76,13.76,0,0,1-1.94,1.8,7.63,7.63,0,0,1-2.27-3.53,19.21,19.21,0,0,0,16.11-16.82c0-.31.07-.63.09-.94,0-.13,0-.26,0-.39s0-.37,0-.55,0-.33,0-.5v-.41c0-.19,0-.39,0-.58s0-.21,0-.31,0-.44-.06-.65a1.79,1.79,0,0,0,0-.23l-.09-.7,0-.15c0-.25-.08-.5-.13-.75l0-.08c-.05-.27-.11-.53-.18-.8h0a19.26,19.26,0,0,0-2.11-5.18,19.29,19.29,0,0,0,1.52-5.56c0-.35.07-.69.09-1s0-.44,0-.66,0-.22,0-.32c0-.29,0-.58,0-.86a.28.28,0,0,1,0-.09,19.44,19.44,0,0,0-5.39-12.86,11.25,11.25,0,0,0,.95-2h0c.08-.21.15-.42.21-.64h0c.06-.21.12-.41.17-.62v-.05l.12-.57a.3.3,0,0,1,0-.1c0-.22.07-.45.1-.68s0-.47.06-.7c0-.07,0-.15,0-.22s0-.33,0-.49v-.24c0-.16,0-.33,0-.49s0-.14,0-.21a11.83,11.83,0,0,0-23.58-.53,12.21,12.21,0,0,0,.11,3.63A19.35,19.35,0,0,0,404.9,87.43a19.62,19.62,0,0,0-.11,3.24,19.51,19.51,0,0,0-3,9h0c0,.12,0,.24,0,.36,0,.4-.05.81-.05,1.21a19.43,19.43,0,0,0,7.47,15.37,13.67,13.67,0,0,0,3.78,4,15.07,15.07,0,0,1,.61,2.5,7.58,7.58,0,0,1-2.3,6.21c-.43.36-.91.66-1.36,1a2.53,2.53,0,0,0-1.39,0c-5.16,1.62-10.1,4.83-12.47,9.74a19,19,0,0,0-1.24,3.48l-.28.43a50,50,0,0,0-6.66,16c-.65,2.91-1.06,5.93-2.42,8.58a8.86,8.86,0,0,0-.79,1.75,17.47,17.47,0,0,0-.12,2.81c-.14,1.7-1.13,3.21-1.46,4.88-.2,1-.16,2-.33,3a30.59,30.59,0,0,1-1.87,5c-1.06,2.94-1.05,6.17-1.84,9.2a3.23,3.23,0,0,1-.62,1.37,7.05,7.05,0,0,1-2.08,1.12,4.59,4.59,0,0,0-2.09,3.13,13.77,13.77,0,0,0-.07,3.9l.39,5.07-5.68,1.72-9.32,2.85a27.74,27.74,0,0,0-7.74,3.27,14.23,14.23,0,0,0-4.88,5.92,29.82,29.82,0,0,0-1.81,7.73,117.42,117.42,0,0,1-4.79,21.8c-.19.54-.39,1.09-.59,1.63h0l-.63,1.59c-.05.11-.1.22-.14.33l-.54,1.27c-.24.54-.49,1.07-.75,1.6l21.83,7.28c0,.26.05.54.09.85.76,5.36.39,10.8,1.09,16.17a10.45,10.45,0,0,0,.61,2.61,3.72,3.72,0,0,0-1.15,1.82,9.68,9.68,0,0,0-.11,3.48c.25,2.74.49,5.48.74,8.22a12.72,12.72,0,0,1,0,3c-.27,1.81-1.31,3.4-1.88,5.13s-.54,3.95.89,5a3.54,3.54,0,0,0,3.44.31,8.08,8.08,0,0,0,2.85-2.19c4.39-4.88,6.36-11.47,9.77-17.1a32.24,32.24,0,0,0,2.34-4.07c.47-1.09.77-2.25,1.15-3.38a34.71,34.71,0,0,1,1.88-4.39c.41-.81,2-2.76,1.64-3.66-.56-1.55-6.55-2.91-8-3.39a4,4,0,0,0-2.93-.13,1.84,1.84,0,0,0-.4.26l-.51-6.61c.89-.08,1.77-.19,2.64-.34q0-1.86-.09-3.75c0-1.14-.05-2.29-.08-3.44-.06-2.8-.12-5.6-.19-8.35a46.26,46.26,0,0,0-.31-4.85c-.34-2.45-1.09-4.85-1.33-7.32a2.79,2.79,0,0,1,1.24-.56h0a8.78,8.78,0,0,1,2.12-.08l.56,0a18.16,18.16,0,0,0,8.83-2.44c2.75-1.43,5.3-3.22,8-4.69l1-.53.38-.19.64-.32.53-.25.12-.06c1.59-.76,3.2-1.5,4.74-2.33a5.36,5.36,0,0,0,.34.49,3.19,3.19,0,0,0,3.33,1.21c-1.89,4.55-4.11,8.95-4.67,13.87-.82,7.11,2,14,4.81,20.62l8.89,21c1,2.32,2.29,4.92,4.72,5.47a7,7,0,0,0,4.46-.89c4.07-1.94,7.73-4.72,11.46-7.32l.15.12c3.37,2.66,5.48,6.37,7.81,9.92l6.23,10.24a3.09,3.09,0,0,0,.25,1.5,8.73,8.73,0,0,0,1.75,2.27,29.49,29.49,0,0,1,7.5,15.35,9.43,9.43,0,0,0,1.24,4.18c1.67,2.32,5.23,2.17,7.74.85a4.88,4.88,0,0,0,1.94-1.6,6.32,6.32,0,0,0,.78-2.42,33.39,33.39,0,0,0,.75-6.44C469.31,313.69,467.8,309.78,467.08,305.75ZM431.31,117.33a14.62,14.62,0,0,0,1.26-.93,19.34,19.34,0,0,1-4,6.86h0c-.42.46-.87.89-1.33,1.31l0-.32c-.05-1,0-2.11,0-3.17A13.38,13.38,0,0,0,431.31,117.33ZM396,196.24l.06-.19a3.82,3.82,0,0,1,.91.93,3.78,3.78,0,0,0,.14,3.39c.52.88,1.46,1.7,1.26,2.71s-1.48,1.41-2.52,1.58c-1.37.22-2.72.47-4.07.74,0,0,0,0,0-.07a10.5,10.5,0,0,0-.45-3.33C393.66,201,395.1,198.62,396,196.24Z",
  transform: "translate(-30.47 -58.05)",
  fill: "url(#a555fdc1-543d-4707-ad9f-6ab871925265)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M437.62,79.82a11.87,11.87,0,1,0-22-7.49,11.63,11.63,0,0,0,.11,3.59,19,19,0,0,0-10.84,18.13A19.08,19.08,0,1,0,440,104.46c0-.31,0-.61,0-.91a19.09,19.09,0,0,0-2.33-23.73Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#46455b"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M415.59,72.91l.16-.09a6.17,6.17,0,0,1-.09-.62.59.59,0,0,0,0,.13A5.44,5.44,0,0,0,415.59,72.91Z",
  transform: "translate(-30.47 -58.05)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M442.9,92.33a19,19,0,0,1-2.95,8.13c0,.3,0,.6,0,.9a19.08,19.08,0,0,1-38.09,1.54c0,.52-.07,1-.07,1.56a19.08,19.08,0,0,0,38.16,0c0-.31,0-.61,0-.91a18.89,18.89,0,0,0,2.95-8.13,18.41,18.41,0,0,0,.07-3.85C443,91.82,442.94,92.08,442.9,92.33Z",
  transform: "translate(-30.47 -58.05)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M439.19,72.19a11.91,11.91,0,0,1-1.57,4.54c.34.34.65.7,1,1.06a11.83,11.83,0,0,0,.62-2.61A11.5,11.5,0,0,0,439.19,72.19Z",
  transform: "translate(-30.47 -58.05)"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M360.74,284.52a8.65,8.65,0,0,0,.87,3.12,3.42,3.42,0,0,0,2.53,1.85,5.1,5.1,0,0,0,2.79-.81c1.69-.89,3.46-1.92,4.34-3.62s.74-3.6.59-5.45l-1.14-14.55c-2.74-.08-5.5-.08-8.25.07s-3.2.79-2.82,3.45C360.4,273.86,360,279.23,360.74,284.52Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#fbbebe"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M441.36,294.35l6.53,10.56a2.6,2.6,0,0,0,1.43,1.34,2.17,2.17,0,0,0,1.36-.24,17,17,0,0,0,5.45-4.52,10,10,0,0,0,2.62-4,5.11,5.11,0,0,0-1.3-4.81A15.37,15.37,0,0,0,455,290.9c-5.17-3.49-7.5-10.11-12.6-13.69a2,2,0,0,0-1-.45,2.2,2.2,0,0,0-1.06.36l-7,3.82c-3,1.65-2.07,1.85.23,3.63C436.92,287.19,439,290.85,441.36,294.35Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#fbbebe"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M374.93,276.1A4,4,0,0,0,372,276a3.22,3.22,0,0,0-1.53,2.41c-.18,1-.16,2-.43,2.93a10,10,0,0,1-2.85,4,4.26,4.26,0,0,1-1.79,1.25c-.95.24-1.95-.2-2.91,0a3.18,3.18,0,0,0-2.29,2.34,9.18,9.18,0,0,0-.11,3.43l.74,8.1a12.39,12.39,0,0,1,0,3c-.27,1.79-1.31,3.35-1.88,5.06s-.55,3.89.89,5a3.61,3.61,0,0,0,3.45.3,8,8,0,0,0,2.85-2.16c4.4-4.8,6.37-11.31,9.79-16.85a32.36,32.36,0,0,0,2.34-4c.47-1.08.77-2.22,1.15-3.33a33.19,33.19,0,0,1,1.89-4.33c.4-.8,2-2.72,1.64-3.61C382.42,277.92,376.41,276.57,374.93,276.1Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#46455b"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M454.34,298.47a8.42,8.42,0,0,1-4.64,4,4.27,4.27,0,0,0-1.57.81,2.44,2.44,0,0,0-.28,2.67,8.63,8.63,0,0,0,1.76,2.24,28.93,28.93,0,0,1,7.5,15.13,9.41,9.41,0,0,0,1.25,4.13c1.67,2.29,5.24,2.14,7.76.83a5,5,0,0,0,1.94-1.57,6.18,6.18,0,0,0,.78-2.39,32.48,32.48,0,0,0,.75-6.35c0-4-1.56-7.89-2.28-11.85-1-5.63-.52-11.7-3.14-16.78A3.7,3.7,0,0,0,463,287.8a4.21,4.21,0,0,0-2.14-.48c-2.36-.09-4.74-.11-7.11-.06-.66,0-1.44.1-1.78.67a2.06,2.06,0,0,0,.26,1.93C453.68,292.73,456.06,295,454.34,298.47Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#46455b"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M398.08,197.57a3.67,3.67,0,0,0-.86,4.62c.53.87,1.47,1.68,1.26,2.68s-1.48,1.38-2.52,1.55c-9.18,1.46-18.12,4.15-27,6.83l-9.34,2.81a27.87,27.87,0,0,0-7.76,3.22,14,14,0,0,0-4.88,5.83,29,29,0,0,0-1.82,7.62c-1.4,9.55-3.19,19.18-7.45,27.84L360.34,268a33.26,33.26,0,0,0,6.79,1.7,24.86,24.86,0,0,0,6.61-.32c-.14-5.05-.23-10.26-.37-15.32a42.31,42.31,0,0,0-.31-4.78c-.34-2.42-1.09-4.78-1.33-7.22,1-.86,2.57-.64,3.92-.61a18.55,18.55,0,0,0,8.86-2.39c2.74-1.42,5.3-3.18,8-4.63,4.55-2.41,9.73-4,13.21-7.83-1.77,6.75-6,12.63-6.77,19.56s2,13.85,4.83,20.32l8.91,20.68c1,2.28,2.29,4.85,4.72,5.39a7.15,7.15,0,0,0,4.47-.88c8.2-3.84,14.76-11.07,23.52-13.37-.66-4.34-4.08-7.93-6-11.86-1.64-3.31-2.17-7.05-3.26-10.58s-3-7.12-6.26-8.8c-1.57-.79-3.68-1.49-3.82-3.24a3.58,3.58,0,0,1,.35-1.63,21.07,21.07,0,0,1,5.33-7.75,2.49,2.49,0,0,0,.7-.88,2.79,2.79,0,0,0,.05-1c-.17-2.82,1.34-5.45,3-7.72s3.63-4.42,4.58-7.07c1.63-4.57,0-9.59-1.6-14.16a14.26,14.26,0,0,0-2.68-5.19c-2.1-2.24-5.36-2.89-8.42-3.23C417.52,194.07,405.93,191.48,398.08,197.57Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#46455b"
});

var _ref23 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M435.52,217.58c-1.68,2.27-3.19,4.9-3,7.72a2.79,2.79,0,0,1-.05,1,2.49,2.49,0,0,1-.7.88,21.07,21.07,0,0,0-5.33,7.75,3.6,3.6,0,0,0-.35,1.63,3.13,3.13,0,0,0,2,2.34,21,21,0,0,1,3.7-4.5,2.49,2.49,0,0,0,.7-.88,2.79,2.79,0,0,0,.05-1c-.17-2.82,1.34-5.45,3-7.72s3.63-4.42,4.58-7.07a14.68,14.68,0,0,0,.24-8q-.1.39-.24.78C439.15,213.16,437.21,215.32,435.52,217.58Z",
  transform: "translate(-30.47 -58.05)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M397.05,198.94a1.89,1.89,0,0,0,1.43-1.29,1.29,1.29,0,0,0,0-.39l-.43.31A3.48,3.48,0,0,0,397.05,198.94Z",
  transform: "translate(-30.47 -58.05)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M367.13,262.48a33.26,33.26,0,0,1-6.79-1.7l-20-6.56a57.52,57.52,0,0,1-2.65,6.35L360.34,268a33.26,33.26,0,0,0,6.79,1.7,24.86,24.86,0,0,0,6.61-.32c-.07-2.37-.12-4.78-.18-7.19A24.75,24.75,0,0,1,367.13,262.48Z",
  transform: "translate(-30.47 -58.05)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.91,284.45a7.15,7.15,0,0,1-4.47.88c-2.43-.54-3.74-3.11-4.72-5.39l-8.91-20.68c-2-4.55-3.95-9.28-4.67-14.13-.06.34-.11.68-.16,1-.81,7,2,13.85,4.83,20.32l8.91,20.68c1,2.28,2.29,4.85,4.72,5.39a7.15,7.15,0,0,0,4.47-.88c8.2-3.84,14.76-11.07,23.52-13.37a17,17,0,0,0-2.69-6.33C435.28,274.87,429.25,281,421.91,284.45Z",
  transform: "translate(-30.47 -58.05)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M405.75,219.38c-3.48,3.8-8.66,5.42-13.21,7.83-2.73,1.45-5.29,3.21-8,4.63a18.56,18.56,0,0,1-8.86,2.4c-1.35,0-2.87-.26-3.92.6.22,2.25.87,4.44,1.24,6.67a12,12,0,0,1,2.68-.06,18.55,18.55,0,0,0,8.86-2.39c2.74-1.42,5.3-3.18,8-4.63,3-1.59,6.27-2.83,9.15-4.59A78.87,78.87,0,0,0,405.75,219.38Z",
  transform: "translate(-30.47 -58.05)"
}));

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M413.69,126a7.39,7.39,0,0,1-2.3,6.11c-.55.47-1.2.82-1.73,1.31a4.69,4.69,0,0,0,.68,7.13c1.8,1.1,4.09.8,6.17.44a35.64,35.64,0,0,0,8.1-2.11,13.39,13.39,0,0,0,6.38-5.23,7.86,7.86,0,0,1-3.63-6.5c-.14-2.59.57-5.53-1.07-7.54s-4.55-1.92-7-1.26c-1.21.34-2.38.8-3.59,1.13-.62.16-2.64.17-3,.62C412,120.92,413.62,124.69,413.69,126Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#fbbebe"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M413.69,126a7.39,7.39,0,0,1-2.3,6.11c-.55.47-1.2.82-1.73,1.31a4.69,4.69,0,0,0,.68,7.13c1.8,1.1,4.09.8,6.17.44a35.64,35.64,0,0,0,8.1-2.11,13.39,13.39,0,0,0,6.38-5.23,7.86,7.86,0,0,1-3.63-6.5c-.14-2.59.57-5.53-1.07-7.54s-4.55-1.92-7-1.26c-1.21.34-2.38.8-3.59,1.13-.62.16-2.64.17-3,.62C412,120.92,413.62,124.69,413.69,126Z",
  transform: "translate(-30.47 -58.05)",
  opacity: 0.1
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 390.17,
  cy: 54.4,
  r: 13.41,
  fill: "#fbbebe"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M378.3,215.31a9.08,9.08,0,0,1-1.26,3,13.88,13.88,0,0,0-1.6,9.15,9.63,9.63,0,0,0,5.63,7.12,3.85,3.85,0,0,0,3.85-.24c-1.79-2.33-1.89-5.51-1.78-8.45a2.83,2.83,0,0,1,.37-1.57,1,1,0,0,1,1.42-.25,12.62,12.62,0,0,0,1.05,5.39c.28.65.76,1.37,1.48,1.35,1,0,1.29-1.41,1.25-2.43-.15-4.16-.36-8.49-2.36-12.13a14.35,14.35,0,0,1-2-4.09,2.42,2.42,0,0,0-.52-1.43,1.79,1.79,0,0,0-.75-.35c-1.15-.33-3.89-1.34-4.84-.26S378.48,213.93,378.3,215.31Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#fbbebe"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M398.21,144.08c-1.54-.18-2.75,1.23-3.59,2.53a48.9,48.9,0,0,0-6.68,15.82c-.65,2.87-1.05,5.85-2.42,8.46a8.62,8.62,0,0,0-.79,1.72,18.31,18.31,0,0,0-.12,2.78c-.14,1.67-1.13,3.16-1.46,4.81-.2,1-.16,2-.34,3-.3,1.72-1.25,3.26-1.86,4.91-1.07,2.9-1.06,6.08-1.85,9.07a3.11,3.11,0,0,1-.62,1.34c-.53.59-1.39.73-2.08,1.11a4.52,4.52,0,0,0-2.1,3.09,13.34,13.34,0,0,0-.07,3.84l.62,7.93c.63-.27,1-1,1.58-1.43,1-.8,2.39-.62,3.63-.4l1.81.33c1.85.33,3.86.76,5,2.22.94-1.48.41-3.65,1.85-4.63.47-.32,1.06-.42,1.55-.7a3.47,3.47,0,0,0,1.58-2.78,10.26,10.26,0,0,0-.45-3.29c2.32-1,3.76-3.33,4.67-5.68a47.52,47.52,0,0,0,2.16-8.76c2.09-11.79,4-23.66,4.2-35.63a17.13,17.13,0,0,0-.65-5.93C401.16,145.91,400.2,144.3,398.21,144.08Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M398.21,144.08c-1.54-.18-2.75,1.23-3.59,2.53a48.9,48.9,0,0,0-6.68,15.82c-.65,2.87-1.05,5.85-2.42,8.46a8.62,8.62,0,0,0-.79,1.72,18.31,18.31,0,0,0-.12,2.78c-.14,1.67-1.13,3.16-1.46,4.81-.2,1-.16,2-.34,3-.3,1.72-1.25,3.26-1.86,4.91-1.07,2.9-1.06,6.08-1.85,9.07a3.11,3.11,0,0,1-.62,1.34c-.53.59-1.39.73-2.08,1.11a4.52,4.52,0,0,0-2.1,3.09,13.34,13.34,0,0,0-.07,3.84l.62,7.93c.63-.27,1-1,1.58-1.43,1-.8,2.39-.62,3.63-.4l1.81.33c1.85.33,3.86.76,5,2.22.94-1.48.41-3.65,1.85-4.63.47-.32,1.06-.42,1.55-.7a3.47,3.47,0,0,0,1.58-2.78,10.26,10.26,0,0,0-.45-3.29c2.32-1,3.76-3.33,4.67-5.68a47.52,47.52,0,0,0,2.16-8.76c2.09-11.79,4-23.66,4.2-35.63a17.13,17.13,0,0,0-.65-5.93C401.16,145.91,400.2,144.3,398.21,144.08Z",
  transform: "translate(-30.47 -58.05)",
  opacity: 0.1
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M432,131.24a16.92,16.92,0,0,1-8.15,4.74,50,50,0,0,1-9.45,1.39,6,6,0,0,1-2.92-.25,2,2,0,0,1-1.21-2.39,2.86,2.86,0,0,0,.35-.93c0-.82-1.22-.89-2-.65-5.16,1.6-10.11,4.76-12.49,9.61a29,29,0,0,0-2.22,8.84c-1.12,8-2.24,16.07-.74,24,.81,4.21,2.35,8.3,2.44,12.58.06,2.4-.35,4.79-.33,7.19a3.63,3.63,0,0,0,.64,2.37c.37.43.93.7,1.19,1.21.43.84-.15,2,.42,2.77.71.94,2.17.26,3.14-.4a24.94,24.94,0,0,1,16.59-4.17c7,.75,14,4.5,20.82,2.62a9.53,9.53,0,0,1-.9-1.62c-3.4-11.16-3.17-23.65,1.92-34.15,1.73-3.59,4-7,4.7-10.94a21,21,0,0,0,.07-5.55,23,23,0,0,0-3.15-10.19C438.79,134.25,435.58,131.6,432,131.24Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M399.57,218.76a12.37,12.37,0,0,0-.77,4.57,27.59,27.59,0,0,0,.22,4.45,7.12,7.12,0,0,0,1.31,3.5,3.19,3.19,0,0,0,3.34,1.19,3.5,3.5,0,0,0,2-2.24,21.33,21.33,0,0,0,.64-3.06c.58-3,2.18-5.9,2.21-9a2.61,2.61,0,0,0-.17-1.08c-.58-1.27-3.43-2.7-4.82-2.49C401.81,214.87,400.21,217.29,399.57,218.76Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#fbbebe"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M438.26,142.56c-.26,2.67,2.32,4.68,3.34,7.15a12.23,12.23,0,0,1,.7,3.6c.72,8.53.16,17.1-.4,25.63a47.85,47.85,0,0,1-1,8.45c-1.44,5.83-5,10.89-8.45,15.79a13.4,13.4,0,0,1-1.81,2.22,13.57,13.57,0,0,1-3.36,2l-11.9,5.77a23,23,0,0,0-4.23,2.43,11.54,11.54,0,0,0-3.5,4.56c-2.31-1.18-4.71-2.24-7-3.42-.54-.28-1.15-.64-1.24-1.24-.12-.8.72-1.37,1.3-2,1.08-1.07,1.41-2.66,2-4.06,1.92-4.6,6.73-7.54,8.47-12.2.67-1.79.87-3.82,2.06-5.32a13.18,13.18,0,0,1,2.27-2,38.27,38.27,0,0,0,5-5.15,8.75,8.75,0,0,0,1.65-2.41,11.92,11.92,0,0,0,.39-4.22c.09-4.66,2.2-9,3.49-13.48,1.21-4.21,1.72-8.63,3.31-12.72S434,143.66,438.26,142.56Z",
  transform: "translate(-30.47 -58.05)",
  opacity: 0.1
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M439.81,142.56c-.26,2.67,2.31,4.68,3.33,7.15a12.24,12.24,0,0,1,.71,3.6c.71,8.53.16,17.1-.4,25.63a47.85,47.85,0,0,1-1.05,8.45c-1.44,5.83-5,10.89-8.45,15.79a13.4,13.4,0,0,1-1.81,2.22,13.57,13.57,0,0,1-3.36,2l-11.91,5.77a23.66,23.66,0,0,0-4.23,2.43,11.63,11.63,0,0,0-3.5,4.56c-2.31-1.18-4.7-2.24-7-3.42-.54-.28-1.15-.64-1.24-1.24-.13-.8.71-1.37,1.29-2,1.09-1.07,1.42-2.66,2-4.06,1.91-4.6,6.73-7.54,8.47-12.2.67-1.79.87-3.82,2.06-5.32a12.47,12.47,0,0,1,2.27-2,38.27,38.27,0,0,0,5-5.15,8.75,8.75,0,0,0,1.65-2.41,12.16,12.16,0,0,0,.39-4.22c.09-4.66,2.19-9,3.48-13.48,1.22-4.21,1.72-8.63,3.31-12.72S435.57,143.66,439.81,142.56Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M427.28,91.72a19,19,0,0,0-11.9,2.47c.53,0,1.06,0,1.59.12a19.08,19.08,0,0,1,7.33,35.42,19.08,19.08,0,0,0,3-38Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#46455b"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M433.15,102.33a8.69,8.69,0,0,1,.15,6.68c-.09-.27-.19-.54-.31-.81-2.36-5.25-9.62-7.42-16.23-4.85a13.25,13.25,0,0,0-7.83,7.47c-1.68-5.08,1.73-10.9,8-13.34C423.53,94.91,430.79,97.08,433.15,102.33Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#46455b"
});

var _ref36 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M433.19,108.6a19.09,19.09,0,0,0-12.75-16.46,18.93,18.93,0,0,0-5.06,2c.53,0,1.06,0,1.59.12A19.07,19.07,0,0,1,433.19,108.6Z",
  transform: "translate(-30.47 -58.05)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M436.28,94.67a19.11,19.11,0,0,0-12.75-16.46,19.29,19.29,0,0,0-5.06,2.06c.53,0,1.06,0,1.6.12A19.06,19.06,0,0,1,436.28,94.67Z",
  transform: "translate(-30.47 -58.05)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M436.36,73.88A11.51,11.51,0,0,0,428.67,64a11.48,11.48,0,0,0-3.06,1.23c.32,0,.64,0,1,.08A11.5,11.5,0,0,1,436.36,73.88Z",
  transform: "translate(-30.47 -58.05)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M443.5,106a19.11,19.11,0,0,1-14.78,20.16,19.2,19.2,0,0,1-4.42,3.56A19.08,19.08,0,0,0,443.5,106Z",
  transform: "translate(-30.47 -58.05)"
}));

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M612.69,305.71a7.35,7.35,0,0,0-8.79-.43c-2,1.48-2.87,3.94-3.69,6.26-1.2,3.43-3.14,6.76-3.46,10.39-.89,10-7.9,18.41-10,28.21-.77,3.5-.92,7.18-2.37,10.45a31.49,31.49,0,0,1-2.4,4.13,109.3,109.3,0,0,0-9,17.43c-1.74.53-3.17,2.2-4.56,3.53a17,17,0,0,1-6.25,3.8,6.17,6.17,0,0,0-2.59,1.27c-1,1.06-1,2.77-1.83,4a5.92,5.92,0,0,1-2.28,1.87,8.55,8.55,0,0,1-.14-.86c-.21-1.53-.38-3.06-.54-4.59a17.32,17.32,0,0,0-2.36-22.35,33.63,33.63,0,0,1,.21-7.16,3.15,3.15,0,0,0-1-3.18c-.49-.31-1.09-.38-1.61-.64a6.53,6.53,0,0,1-1.88-1.93,9,9,0,0,0-11.48-1.7c-2.8,1.87-4.28,5.19-6.67,7.58-1.24,1.23-2.71,2.2-3.94,3.43a17.74,17.74,0,0,0-4.58,9.53,51.89,51.89,0,0,0-.43,10.72,9.8,9.8,0,0,0,.46,3.2,8.41,8.41,0,0,0,1.46,2.32,27.78,27.78,0,0,0,11.24,8.69,4.85,4.85,0,0,1,.05.64c0,.33,0,.66-.08,1l-.49-.08c-1.8-.22-3.7,0-5.37-.69-2.85-1.23-4-4.85-6.81-6.27a4.16,4.16,0,0,0-.73-.3,46.36,46.36,0,0,0-4.07-13.44c-1-2-2.13-4.08-2.25-6.34a16.13,16.13,0,0,1,1.39-6.09,157.35,157.35,0,0,0,5.34-21q1.36-6.69,2.74-13.38a20.1,20.1,0,0,0,3.26-3.81,18.56,18.56,0,0,0,3.26-9.43,12.79,12.79,0,0,0-3.3-9.27,5.48,5.48,0,0,0-4.11-2,5,5,0,0,0-3.44,2A16.45,16.45,0,0,0,517,316.9c-1,3.32-2,6.78-1.55,10.22.41,2.85,1.8,5.94.38,8.44-4.68,8.19-7.91,17.4-11.38,26.18a43.91,43.91,0,0,0-2.18,6.5,34.39,34.39,0,0,0-.36,10.86,143.43,143.43,0,0,0,3.91,20.09c.73,3,1.59,6.17,3.31,8.64a37.26,37.26,0,0,0-.44,10.16,5.62,5.62,0,0,0,.6,2.25,9.58,9.58,0,0,0,2.06,2.11,10.27,10.27,0,0,1,3.27,7.84,23.26,23.26,0,0,0,1.57,8c2.39,7.13,4.79,14.26,6.88,21.49a14.11,14.11,0,0,1,.74,4.15c0,2-.95,4-.51,6a21.37,21.37,0,0,1,.82,2.77,7.18,7.18,0,0,1-.28,2.15c-1.3,5.65-5.06,18.68-4.41,24.45l1.29-.45c-.55,7.64-2.91,15.12-3.77,22.76a74.8,74.8,0,0,0,.18,16.72,58.83,58.83,0,0,1,.64,7.49c0,2.25-.36,4.47-.45,6.71a61.14,61.14,0,0,0,.53,9,93,93,0,0,0,2.23,13.89c2.08,7.76.68,15.84.91,23.88a145.35,145.35,0,0,1-.17,16.83c-.21,2.37-.54,4.73-.61,7.11-.21,7.06,1.88,14.09,1.14,21.11-.35,3.29-1.19,7,.88,9.59.66.81,1.55,1.39,2.25,2.16a3,3,0,0,1,.87,2.85c-.27.79-1,1.37-1.17,2.2-.19,1.3,1.24,2.2,2.48,2.62l.35.1a3.09,3.09,0,0,0,.89,2.36,5.3,5.3,0,0,0,2.67,1.06l16,3.1c3.57.69,7.45,1.34,10.8.13a2.74,2.74,0,0,0,.75,1.27,5.3,5.3,0,0,0,2.66,1.06l16,3.1c4.08.79,8.56,1.52,12.2-.5a6.86,6.86,0,0,0,2.57-2.39,7.41,7.41,0,0,0,.35-6.25,5.11,5.11,0,0,0-1.78-2.59,6.64,6.64,0,0,0-3.72-.8,7.34,7.34,0,0,1-3.22-.49,2.39,2.39,0,0,1-.8-.68c.8-1,1.57-2,2.3-3-.69-.16-1-1.11-1.17-1.81-2.06-10.38.83-21,1.25-31.6a67.3,67.3,0,0,0-1.24-15.83c-.39-2-.86-3.9-1.14-5.88-1.47-10.33,2.46-20.82,1.21-31.18-.59-4.84,1.49-9.9,2.23-14.72.65-4.28.23-8.64-.19-13l-3.31-34c-.45-4.59-.92-9.29-2.88-13.47a17.64,17.64,0,0,1-1.36-7.39c4-2.29,7.68-5.44,12.2-5.45.87-3.3-1.63-13.71-3.09-16.79a73.25,73.25,0,0,1-6.51-38.95c.53-4.79-1.38-9.62-.74-14.4a8.67,8.67,0,0,1,.92-3.21,3.31,3.31,0,0,1,2.66-1.77c-.28-2.87-.65-5.76-1.14-8.63a21,21,0,0,0,4-5.75c2.08-4.35,3-9.15,4.21-13.81,2.2-8.21,5.56-16.05,8.22-24.11s2.14-16.58,4.05-24.86a18.24,18.24,0,0,1,7.8-11.09c1.52-1,3.25-1.77,4.3-3.25a7.42,7.42,0,0,0,1.2-4.09A10.47,10.47,0,0,0,612.69,305.71ZM551.57,655.59c.3-.41.59-.82.86-1.25-1.06-.06-2.4-.68-2.53-1.74a11.29,11.29,0,0,1,.35-3.15,12.52,12.52,0,0,0-.33-5.51c-.37-1.24-.92-2.43-1.32-3.67a37.13,37.13,0,0,1-.93-4.21,71.91,71.91,0,0,0-4.55-14.79c-2-4.61-.45-9.64-.43-14.67,0-2.37-.36-4.79.24-7.09.35-1.36,1-2.62,1.37-4,.82-3.17-.21-6.5-1.22-9.61,3.95-9.34,4.48-20,5.29-30.16q.68-8.52,1.36-17c.2-2.53.43-5.16,1.76-7.32a87.26,87.26,0,0,1,4.19,22.31,33.85,33.85,0,0,0,.76,6.52c.63,2.37,1.86,4.52,2.68,6.82,1.82,5.06,1.63,10.59,2.45,15.9.33,2.15.83,4.27,1.15,6.42,1.38,9.49-.85,19.1-3.07,28.43-1.36,5.72-1.14,12.05-1.45,17.92-.29,5.63-.59,11.26-.45,16.9,0,1.72.11,3.48.09,5.23a12.78,12.78,0,0,0-1.64-.09,7.34,7.34,0,0,1-3.22-.49A3.67,3.67,0,0,1,551.57,655.59Z",
  transform: "translate(-30.47 -58.05)",
  fill: "url(#b5cd2d76-14a4-40b4-8065-15ea8dd506d0)"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M586.45,663.39a6.74,6.74,0,0,1,3.72.79,5.18,5.18,0,0,1,1.78,2.58,7.33,7.33,0,0,1-.36,6.21,6.81,6.81,0,0,1-2.57,2.37c-3.64,2-8.12,1.29-12.2.51l-16-3.07a5.32,5.32,0,0,1-2.67-1,3.46,3.46,0,0,1-.47-4,7.66,7.66,0,0,1,3-3c4.6-2.86,10-4,15.28-4.61,2-.24,3.87-.88,5.37.51.8.73.76,1.64,1.88,2.23A7.48,7.48,0,0,0,586.45,663.39Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#3f3d56"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M556.22,657.89a6.7,6.7,0,0,1,3.71.79,5.06,5.06,0,0,1,1.78,2.58,7.29,7.29,0,0,1-.35,6.21,6.89,6.89,0,0,1-2.57,2.37c-3.64,2-8.12,1.29-12.21.51l-16-3.08a5.31,5.31,0,0,1-2.67-1,3.46,3.46,0,0,1-.48-4,7.85,7.85,0,0,1,3.05-3c4.59-2.85,10-3.95,15.28-4.6,2-.25,3.87-.88,5.37.5.79.73.76,1.64,1.87,2.23A7.4,7.4,0,0,0,556.22,657.89Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#3f3d56"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M552.28,487.89A192.23,192.23,0,0,0,524.65,490a5.52,5.52,0,0,0-1.75.46c-1.94,1-2,3.72-1.95,5.9.13,8.87-2.9,17.46-3.9,26.26a73.23,73.23,0,0,0,.17,16.61,62.05,62.05,0,0,1,.64,7.45c0,2.22-.37,4.43-.46,6.66a60.32,60.32,0,0,0,.52,8.9,91.85,91.85,0,0,0,2.23,13.8c2.07,7.71.67,15.74.89,23.72a141.27,141.27,0,0,1-.19,16.72c-.21,2.36-.54,4.7-.61,7.07-.21,7,1.87,14,1.13,21-.35,3.26-1.2,7,.87,9.52.66.8,1.55,1.38,2.24,2.15a3,3,0,0,1,.88,2.82c-.28.79-1.05,1.37-1.17,2.19-.2,1.29,1.23,2.19,2.47,2.6a22.86,22.86,0,0,0,25.79-9.27c-1.06-.06-2.4-.68-2.53-1.73a11.15,11.15,0,0,1,.35-3.13,12.19,12.19,0,0,0-.33-5.47c-.36-1.24-.92-2.42-1.31-3.65a37.11,37.11,0,0,1-.93-4.18,70.67,70.67,0,0,0-4.54-14.7c-2-4.58-.44-9.58-.42-14.56,0-2.36-.35-4.77.24-7.05.35-1.36,1-2.61,1.38-4,.82-3.15-.21-6.45-1.22-9.54,4-9.28,4.5-19.92,5.31-30l1.37-17c.2-2.51.44-5.13,1.76-7.27a86.13,86.13,0,0,1,4.19,22.16,32.77,32.77,0,0,0,.75,6.49c.63,2.34,1.85,4.48,2.68,6.77,1.81,5,1.62,10.51,2.44,15.79.33,2.14.82,4.24,1.14,6.38,1.38,9.43-.86,19-3.09,28.25-1.36,5.68-1.15,12-1.46,17.81-.3,5.59-.6,11.18-.46,16.78.12,5.15.52,10.68-2.25,15,3.1,1.58,6.3,3.19,9.76,3.49a17.25,17.25,0,0,0,11.23-3.4,36.5,36.5,0,0,0,8.23-8.63c-.7-.16-1-1.11-1.17-1.8-2.06-10.31.84-20.9,1.27-31.4a66.81,66.81,0,0,0-1.23-15.72c-.39-2-.87-3.89-1.15-5.85-1.45-10.26,2.48-20.69,1.24-31-.58-4.82,1.5-9.84,2.24-14.64.65-4.25.24-8.58-.18-12.86l-3.29-33.75c-.44-4.57-.91-9.24-2.87-13.39-2.34-5-.89-11.16-1.14-16.67A68.62,68.62,0,0,1,552.28,487.89Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#46455b"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M571.6,387.94a107.45,107.45,0,0,1,10.54-21.2,31.27,31.27,0,0,0,2.4-4.11c1.46-3.24,1.61-6.9,2.38-10.38,2.15-9.74,9.17-18.1,10.07-28,.32-3.61,2.26-6.92,3.47-10.33.81-2.31,1.73-4.75,3.69-6.22a7.4,7.4,0,0,1,8.78.42,10.33,10.33,0,0,1,3.55,8.41,7.4,7.4,0,0,1-1.2,4.06c-1.06,1.47-2.78,2.26-4.3,3.23a18.15,18.15,0,0,0-7.81,11c-1.92,8.23-1.4,16.68-4.07,24.69s-6,15.81-8.23,24c-1.25,4.63-2.14,9.4-4.23,13.72s-5.64,8.22-10.31,9.33a27.92,27.92,0,0,0-2.28-8.61C572.65,394.79,570.42,391.15,571.6,387.94Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#a0616a"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M521.29,399.35a45.62,45.62,0,0,0-4.44-16.83c-1-2-2.12-4-2.24-6.29a15.89,15.89,0,0,1,1.39-6.05,155.94,155.94,0,0,0,5.35-20.91l2.76-13.3a20.23,20.23,0,0,0,3.25-3.78,18.34,18.34,0,0,0,3.27-9.37,12.64,12.64,0,0,0-3.29-9.22,5.49,5.49,0,0,0-4.11-1.94,5,5,0,0,0-3.44,2,16.12,16.12,0,0,0-2.55,5.6c-1,3.3-2,6.73-1.56,10.15.4,2.83,1.8,5.9.37,8.38-4.69,8.15-7.92,17.29-11.4,26a43.78,43.78,0,0,0-2.17,6.46,34,34,0,0,0-.38,10.8,141.76,141.76,0,0,0,3.9,20c1,4.12,2.25,8.6,5.71,11.07C514.56,407.56,517.44,403.09,521.29,399.35Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#a0616a"
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  cx: 510.33,
  cy: 325.28,
  r: 17.17,
  fill: "#a0616a"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M534.39,402.16c-.1,3.13-1.46,6.06-2.8,8.9-.81,1.71-1.87,3.62-3.72,4A83.24,83.24,0,0,0,544,419.69a17.74,17.74,0,0,0,5.76.33,13.84,13.84,0,0,0,4.59-1.7,23.54,23.54,0,0,0,11.67-17,31,31,0,0,1-6.39.17,4.68,4.68,0,0,1-3.27-1.21,4.91,4.91,0,0,1-.92-2.68q-.57-4.26-.91-8.54a33.84,33.84,0,0,0-12.25,2.81c-1.6.7-3.16,1.51-4.81,2.11-1,.36-3.89.43-4.59,1.08C531.8,396.09,534.45,400,534.39,402.16Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#a0616a"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M543,411.76a10.8,10.8,0,0,0-9.14-8.69c-1.8-.21-3.7,0-5.37-.67-2.85-1.23-4.05-4.82-6.81-6.23s-6.34-.1-8.38,2.26S510.4,404,509.78,407a41.5,41.5,0,0,0-.93,12.7,5.7,5.7,0,0,0,.61,2.24,9.71,9.71,0,0,0,2.05,2.1,10.14,10.14,0,0,1,3.27,7.78,22.8,22.8,0,0,0,1.56,8c2.39,7.08,4.79,14.17,6.87,21.35a13.85,13.85,0,0,1,.74,4.12c-.05,2-1,4-.51,5.95a23.25,23.25,0,0,1,.81,2.75,7.08,7.08,0,0,1-.28,2.14c-1.31,5.62-5.07,18.56-4.42,24.29,8.53-3.14,21.4-5,30.44-6a67,67,0,0,1,7.49-.44c6,0,12.29,1.13,17.89-1.07,5.19-2,9.5-6.82,15.08-6.84.87-3.27-1.63-13.61-3.08-16.67a72.22,72.22,0,0,1-6.48-38.69c.52-4.76-1.38-9.56-.73-14.31a8.56,8.56,0,0,1,.91-3.19,3.36,3.36,0,0,1,2.67-1.77,105,105,0,0,0-4.35-21.94c-.81-2.54-2.27-5.48-4.93-5.65-2.4-.16-4.17,2-5.9,3.69a17,17,0,0,1-6.25,3.77,6.15,6.15,0,0,0-2.6,1.27c-1,1.05-1,2.76-1.83,4-1.44,2.22-5.12,2.43-6,4.91a15.17,15.17,0,0,0-.39,2.22,7.92,7.92,0,0,1-2.36,3.78A15.24,15.24,0,0,1,543,411.76Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#2f2e41"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M552.79,363.74a3.1,3.1,0,0,0-1-3.15,15.2,15.2,0,0,0-1.62-.65A6.59,6.59,0,0,1,548.3,358a9,9,0,0,0-11.47-1.68c-2.81,1.86-4.28,5.16-6.68,7.53-1.23,1.23-2.7,2.19-3.94,3.42a17.65,17.65,0,0,0-4.59,9.46,51.31,51.31,0,0,0-.43,10.66,9.43,9.43,0,0,0,.46,3.18,8.45,8.45,0,0,0,1.46,2.3,27.3,27.3,0,0,0,11.81,8.86c4.7,1.66,10.19,1.46,14.39-1.23a2.56,2.56,0,0,0,1-1,3.15,3.15,0,0,0,0-1.92,13,13,0,0,1,.69-7.43,49.25,49.25,0,0,0,2.22-5.05,16.9,16.9,0,0,0,.16-6C552.89,374,552,368.86,552.79,363.74Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#46455b"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M843.32,630c0,98.38,61.72,178,138,178",
  transform: "translate(-30.47 -58.05)",
  fill: "#46455b"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M981.32,808c0-99.5,68.87-180,154-180",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M893.32,638.86c0,93.46,39.35,169.09,88,169.09",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M981.32,808c0-127.13,79.61-230,178-230",
  transform: "translate(-30.47 -58.05)",
  fill: "#46455b"
});

var _ref51 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 944.86,
  cy: 778.1,
  rx: 34.31,
  ry: 5.8,
  fill: "#2a9d8f",
  opacity: 0.1
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M952.28,809.2s19.57-.6,25.47-4.8,30.11-9.22,31.57-2.48,29.41,33.5,7.32,33.68-51.34-3.44-57.23-7S952.28,809.2,952.28,809.2Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#a8a8a8"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M1017,833.25c-22.09.18-51.34-3.44-57.23-7-4.48-2.74-6.27-12.53-6.86-17.06l-.66,0s1.24,15.78,7.13,19.37,35.13,7.21,57.23,7c6.37-.05,8.58-2.32,8.46-5.68C1024.21,832,1021.78,833.21,1017,833.25Z",
  transform: "translate(-30.47 -58.05)",
  opacity: 0.2
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M846,94.65a7.55,7.55,0,0,0,1.37-4.2c0-9.12-18.58-16.5-41.5-16.5s-41.5,7.38-41.5,16.5A7.78,7.78,0,0,0,766,95.13c-25.52,2.85-42.71,8.19-42.71,14.32,0,9.11,38,16.5,85,16.5s85-7.39,85-16.5C893.32,103,874,97.35,846,94.65Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f",
  opacity: 0.1
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M337,112.65a7.55,7.55,0,0,0,1.37-4.2c0-9.12-18.58-16.5-41.5-16.5s-41.5,7.38-41.5,16.5a7.78,7.78,0,0,0,1.71,4.68c-25.52,2.85-42.71,8.19-42.71,14.32,0,9.11,38.05,16.5,85,16.5s85-7.39,85-16.5C384.32,121,365,115.35,337,112.65Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f",
  opacity: 0.1
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M628.74,98.79c2.33-1.35,5.48-.06,7.08,2.12s2,5,2.45,7.62c.89,5.92,1.54,12.71-2.45,17.16,6.52-19.77,25.27-34.91,46-37.12",
  transform: "translate(-30.47 -58.05)",
  fill: "none",
  stroke: "#2a9d8f",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.1
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M295.21,199.77c1.5-.87,3.52,0,4.55,1.36a10.71,10.71,0,0,1,1.58,4.9c.57,3.81,1,8.17-1.57,11a35.83,35.83,0,0,1,29.55-23.87",
  transform: "translate(-30.47 -58.05)",
  fill: "none",
  stroke: "#2a9d8f",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.1
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M745.21,229.77c1.5-.87,3.52,0,4.55,1.36a10.71,10.71,0,0,1,1.58,4.9c.57,3.81,1,8.17-1.57,11a35.83,35.83,0,0,1,29.55-23.87",
  transform: "translate(-30.47 -58.05)",
  fill: "none",
  stroke: "#2a9d8f",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.1
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M708.32,566v-24.3l11.2,11.2,2.8-2.9-16-16-16,16,2.8,2.79,11.2-11.09V566Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f",
  opacity: 0.1
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M466.32,646v-24.3l11.2,11.2,2.8-2.9-16-16-16,16,2.8,2.79,11.2-11.09V646Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f",
  opacity: 0.1
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M644.32,717v-24.3l11.2,11.2,2.8-2.9-16-16-16,16,2.8,2.79,11.2-11.09V717Z",
  transform: "translate(-30.47 -58.05)",
  fill: "#2a9d8f",
  opacity: 0.1
});

function SvgJoinMeeting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f6ed740f-4c53-497f-bfef-ebd7a0ab3453",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1139.07,
    height: 783.9,
    viewBox: "0 0 1139.07 783.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "going up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinMeeting);
export default __webpack_public_path__ + "static/media/join-meeting.9f4b56c9.svg";
export { ForwardRef as ReactComponent };